import { useEffect, useRef } from 'react';
import type { GameView } from '@big2/shared';
import { playJanliiCallSound, playStackPickSound } from '../../../daaluuSounds.js';

/**
 * Plays table sounds for everyone when a Janlii is called and whenever a stack is taken from the ring
 * (the starting pick and each collection). Mounting or reconnecting never replays past events.
 */
export function useDaaluuSounds(game: GameView | null) {
  const d = game?.daaluu;
  const roundId = d?.shuffle.roundId;
  const janlii = d?.janlii ?? null;
  const pickKey = d ? `${roundId}:${d.distribution.startIndex ?? '-'}:${d.distribution.lastCollection?.serial ?? '-'}` : '';
  const seen = useRef({ janlii: `${roundId}:${janlii}`, pickKey });

  useEffect(() => {
    const key = `${roundId}:${janlii}`;
    if (janlii && key !== seen.current.janlii) playJanliiCallSound();
    seen.current.janlii = key;
  }, [roundId, janlii]);

  useEffect(() => {
    const picked = d?.distribution.startIndex !== null && d?.distribution.startIndex !== undefined;
    if (picked && pickKey !== seen.current.pickKey) playStackPickSound();
    seen.current.pickKey = pickKey;
  }, [pickKey, d?.distribution.startIndex]);
}
